import { useEffect } from 'react';
import { useDispatch } from 'src/store/store';
import SearchWrapper from 'src/modules/search/shared/components/searchWrapper';
import { DefaultLayout } from 'src/components/layouts';
import { fetchSearchPosts, fetchSearchCommunities, resetSearch } from 'src/modules/search/shared/actions';
import { PageContext, SearchType, SortType } from 'src/constants/types';
type Props = {
  communityId?: string | number;
  page?: string;
  query?: string;
  searchType?: SearchType;
  sort?: SortType;
};
export default function SearchPage({
  communityId = 'all',
  page = '1',
  query = '',
  searchType = 'posts',
  sort = 'most-relevant'
}: Props) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!query) return;
    switch (searchType) {
      case 'communities':
        dispatch(fetchSearchCommunities(query, page));
        break;
      case 'posts':
      default:
        dispatch(fetchSearchPosts(query, page, communityId, sort));
        break;
    }
    return () => {
      dispatch(resetSearch());
    };
  }, [query, page, communityId, sort, searchType, dispatch]);
  return <DefaultLayout isFullWidth={true} data-sentry-element="DefaultLayout" data-sentry-component="SearchPage" data-sentry-source-file="search.tsx">
      <SearchWrapper query={query} searchType={searchType} data-sentry-element="SearchWrapper" data-sentry-source-file="search.tsx" />
    </DefaultLayout>;
}
SearchPage.getInitialProps = ({
  query: {
    searchType,
    query,
    page,
    community,
    sort
  }
}: PageContext) => {
  return {
    communityId: community,
    page,
    query,
    searchType,
    sort
  };
};